// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__FLirb","checkboxCol":"Table_checkboxCol__3_OUX","emailCol":"Table_emailCol__336jR","actionCol":"Table_actionCol__2jl4k"};